export const GBP = (n) =>
  new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP" }).format(Number(n || 0));

export const priceLabel = (s) => (s?.price_type === "from" ? `from ${GBP(s.price)}` : GBP(s?.price));

export const ukDate = (d) => {
  if (!d) return "";
  const date = typeof d === "string" ? new Date(d + (d.length === 10 ? "T00:00:00" : "")) : d;
  return date.toLocaleDateString("en-GB", { day: "2-digit", month: "2-digit", year: "numeric" });
};

export const ukDateLong = (d) => {
  if (!d) return "";
  const date = typeof d === "string" ? new Date(d + (d.length === 10 ? "T00:00:00" : "")) : d;
  return date.toLocaleDateString("en-GB", { weekday: "short", day: "numeric", month: "short", year: "numeric" });
};

export const ymd = (date) => {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
};

export const DAYS = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
export const DAYS_SHORT = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

// JS getDay(): Sunday=0..Saturday=6 -> our Monday=0..Sunday=6
export const jsDayToIdx = (jsDay) => (jsDay + 6) % 7;

export const STATUS_STYLES = {
  booked: "bg-sky-50 text-sky-800 border-sky-200",
  confirmed: "bg-emerald-50 text-emerald-800 border-emerald-200",
  completed: "bg-stone-100 text-stone-700 border-stone-200",
  cancelled: "bg-rose-50 text-rose-800 border-rose-200",
  no_show: "bg-purple-50 text-purple-800 border-purple-200",
};

export const STATUS_LABELS = {
  booked: "Booked",
  confirmed: "Confirmed",
  completed: "Completed",
  cancelled: "Cancelled",
  no_show: "No-show",
};
